// src/types/problem.ts

export interface Problem {
  id: string;
  ticketId: string;
  ticketCreationDatetime: string;
  ticketClosureDatetime: string;
  problemStartDatetime: string;
  problemCloseDatetime: string;
  networkId: string | number | undefined;
  siteId: string | number | undefined;
  linkId: string | number | undefined;
  assetId: string | number | undefined;
  teamId: string | number | undefined;
  personId: string | number | undefined;
  communicationWithCustomer: string;
  userid: any;
  ticketCreation: string;
  ticketClosure: string;
  summary: string;
  problemStart: string;
  problemClose: string;
  affectedCustomer: string[];
  email: string;
  affectedNetwork?: string[];
  affectedSite: string[];
  affectedLink: string[];
  asset: string;
  errorType: string;
  closureCode: string;
  impact: string;
  urgency: string;
  priority: string;
  responsibleTeam: string;
  responsiblePerson: string;
  customerComplaint: boolean;
  customerInformed: boolean;
  status: string;
  journalUpdate: string;
  communication: string;
  sla: string;
  slaStatus: string;
  description: string;
  reactionPoint: string;
  responseTimeToOpen: string;
  responseTimeToClose: string;
  acceptanceTime: string;
  ola: string;
  olaStatus: string;
  foruserid: number[];
  acceptanceStatus: string;
  relatedobject: string[];
  createdby: string;
  closedby: string;
  filePath?: File[] | null;

  solution: string;
}

export const initialProblem: Problem = {
  id: "",
  ticketId: "",
  userid: "",
  ticketCreation: "",
  ticketClosure: "",
  problemStart: "",
  problemClose: "",
  affectedCustomer: [],
  affectedNetwork: [],
  affectedSite: [],
  affectedLink: [],
  asset: "",
  summary: "",
  solution: "",
  description: "",
  errorType: "",
  closureCode: "",
  impact: "",
  urgency: "",
  priority: "",
  responsibleTeam: "",
  responsiblePerson: "",
  customerComplaint: false,
  customerInformed: false,
  foruserid: [],
  email: "",
  status: "",
  journalUpdate: "",
  communication: "",
  sla: "",
  slaStatus: "",
  reactionPoint: "",
  responseTimeToOpen: "",
  responseTimeToClose: "",
  acceptanceTime: "",
  ola: "",
  olaStatus: "",
  ticketCreationDatetime: "",
  ticketClosureDatetime: "",
  problemStartDatetime: "",
  problemCloseDatetime: "",
  networkId: undefined,
  siteId: undefined,
  linkId: undefined,
  assetId: undefined,
  teamId: undefined,
  personId: undefined,
  communicationWithCustomer: "",
  acceptanceStatus: "",
  relatedobject: [],
  createdby: "",
  closedby: "",
};
